import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [barberSlug, setBarberSlug] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
        setBarberSlug(data.barber_slug);
      } catch (e) {
        setUser(null);
        setBarberSlug(null);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    setBarberSlug(data.barber_slug);
    return data;
  };

  const register = async (email, password, studio_name) => {
    const { data } = await api.post("/auth/register", {
      email,
      password,
      studio_name,
    });
    setUser(data.user);
    setBarberSlug(data.barber_slug);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setUser(null);
      setBarberSlug(null);
    }
  };

  const isAdmin = !!user && user.role === "admin";

  return (
    <AuthCtx.Provider
      value={{
        user,
        barberSlug,
        loading,
        isAdmin,
        login,
        register,
        logout,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
